import { RadioOption } from '../RadioField';

export const options: RadioOption[] = [
  {
    value: 'clubCandidate',
    label:
      'Yes, this candidate has been confirmed with another club management system.',
  },
  { value: 'newMember', label: 'No' },
];
